module.exports = __webpack_public_path__ + "static/media/ke.d122fe38.svg";